export const VERTICALS = [
  {
    id: "xno",
    name: "XNO",
    tag: "Faith Vertical",
    desc: "Targeting churches, ministries, and faith-based nonprofits with AI receptionists and member follow-up. Powered by HaloFlow.",
    url: "https://www.xnosolutions.com",
    logo: "https://customer-assets.emergentagent.com/job_growth-partners-hub/artifacts/gfahe563_XNO%20logo%20on%20white.png",
    span: "lg:col-span-3",
  },
  {
    id: "medical",
    name: "MyMedicalMarketing.agency",
    tag: "Medical Vertical",
    desc: "Voice intake, scheduling, and no-show reduction for clinics, dental practices, and medspas.",
    url: "https://www.mymedicalmarketing.agency",
    span: "lg:col-span-3",
  },
  {
    id: "home-services",
    name: "OTBMG Home Services",
    tag: "Home Services",
    desc: "24/7 call answering, booking, and lead follow-up for HVAC, roofing, plumbing, and electrical businesses.",
    url: "#",
    span: "lg:col-span-2",
  },
  {
    id: "legal",
    name: "OTBMG Legal",
    tag: "Legal Vertical",
    desc: "Intake, qualification, and case updates for PI, family, immigration, and small law firms.",
    url: "#",
    span: "lg:col-span-2",
  },
  {
    id: "smb",
    name: "Other SMB Solutions",
    tag: "SMB Vertical",
    desc: "Tailored agentic marketing solutions for automotive services, accountants, and consultants.",
    url: "#",
    span: "lg:col-span-2",
  },
];

export const MEDIA_GROUP_URL = "#";
export const HALOFLOW_URL = "https://www.usehaloflow.com";
export const PHONE_DISPLAY = "404.474.0243";
export const PHONE_TEL = "tel:+14044740243";
export const LOGO_DARK = "https://customer-assets.emergentagent.com/job_growth-partners-hub/artifacts/liiu0nj2_OTB%20logo%20w%20tagline.png";
export const LOGO_MARKETING = "https://customer-assets.emergentagent.com/job_growth-partners-hub/artifacts/ac9hz044_OTBMarketingGroup%20Logo%20400x101.jpg";

export const NAV_LINKS = [
  { label: "Ecosystem", href: "/#ecosystem" },
  { label: "HaloFlow", href: "/#haloflow" },
  { label: "Verticals", href: "/#verticals" },
  { label: "Enterprise", href: "/#enterprise" },
];
